import React, { Component } from 'react';
import { Image, Grid } from 'react-bootstrap';
import './styles.css';
import Data from './revistasData';
import { Link } from 'react-router-dom';
import NotFound from '../../components/notFound';

const ACTUAL_NUMBER = '5';

export default class Revistas extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.routeParam = this.props.match.params;
  }
  componentWillMount() {}
  componentWillReceiveProps(np) {
    if (JSON.stringify(np.match.params) !== JSON.stringify(this.routeParam)) {
      this.routeParam = np.match.params;
    }
  }
  renderColumns() {
    var keys = Object.keys(Data[this.routeParam.type]).filter((ele) => {
      return ele !== 'logo' && ele !== 'description' && ele !== ACTUAL_NUMBER;
    });

    return keys.map((ele) => {
      return (
        <Link to={`/revistas/${this.routeParam.type}/${ele}`} key={`/revistas/${this.routeParam.type}/${ele}`}>
          <li>{Data[this.routeParam.type][ele].title}</li>
        </Link>
      );
    });
  }
  render() {
    if (!Data[this.routeParam.type]) return <NotFound />;
    return (
      <div className="navMargin" style={{ height: '100%' }}>
        <section
          style={{
            paddingTop: '2%',
            backgroundColor: '#352a35',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: '100%',
          }}
        >
          <Image
            src={Data[this.routeParam.type].logo}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
            }}
            responsive
          />
          <Image
            src={require('../../img/lineRevistas.png')}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              marginTop: 20,
              marginBottom: 20,
            }}
            responsive
          />
          <div className="container">
            {/* <p
              style={{ color: "white", fontSize: "18pt", textAlign: "center" }}
            >
              {this.routeParam.type}
            </p>
            <hr /> */}
            <p
              style={{
                color: 'white',
                fontSize: '14pt',
                textAlign: 'justify',
              }}
            >
              {Data[this.routeParam.type].description}
            </p>

            <p
              style={{
                color: 'white',
                fontSize: '18pt',
                marginTop: 50,
              }}
            >
              Número actual
            </p>
            <Link to={`/revistas/${this.routeParam.type}/${ACTUAL_NUMBER}`}>
              <p>{Data[this.routeParam.type][ACTUAL_NUMBER].title}</p>
            </Link>

            <p
              style={{
                color: 'white',
                fontSize: '18pt',
                marginTop: 50,
              }}
            >
              Números anteriores
            </p>
          </div>
          <Grid style={{ marginBottom: 50 }}>
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>{this.renderColumns()}</ul>
          </Grid>

          <div className="container">
            <a
              href={`mailto:editorialtyr@gmail.com?subject=Convocatoria para ${this.routeParam.type} Numero ${
                parseInt(ACTUAL_NUMBER, 10) + 1
              }`}
            >
              <p
                style={{
                  color: 'white',
                  fontSize: '18pt',
                  marginTop: 50,
                }}
              >
                Envío de propuestas
              </p>
            </a>
          </div>

          <div className="container" style={{ marginBottom: 20 }}>
            <hr />
            <p
              style={{
                color: 'white',
                fontSize: '14pt',
                textAlign: 'justify',
              }}
            >
              Axon, Año 2, No. 5, mayo-agosto de 2019, es una publicación cuatrimestral editada por T&R Desarrollo
              Empresarial, SA de CV Avenida Santa Rosa de Lima # 1655, Col. Santa María, Guadalupe, Nuevo León, CP
              67192. Teléfono (81) 84864240. Dirección electrónica: https://tyreditorial.com/revistas, Correo
              electrónico: editorialtyr@gmail.com Editora responsable: Dra. Alma Elena Gutiérrez Leyton. Reservas de
              Derechos al Uso Exclusivo número 04-2018-021912275800-203 otorgado por el Instituto Nacional del Derecho
              de Autor. ISSN: en trámite, ante el Instituto Nacional del Derecho de Autor. Responsable de la última
              actualización de este número: Unidad de Publicaciones de T&R Desarrollo Empresarial, SA de CV, Dr. Moisés
              Torres Herrera. Fecha de la última modificación 20 de agosto de 2020.
            </p>
          </div>
        </section>
      </div>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/revistas/index.js